var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"type":"submit","color":"primary","block":"","loading":_vm.loading},on:{"click":_vm.handleOnClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }